module.exports = __webpack_public_path__ + "img/case-logo-10.aabae8ef.png";